import {
  NETWORK_TRIGGER,
  NetworkQualityContext,
  NetworkSignals,
  NetworkTrigger,
} from '../NetworkStatusProvider.types';

interface AdaptNetworkSignalsToContextArgs {
  signals: NetworkSignals;
  degradedTrigger?: NetworkTrigger;
}

export const adaptNetworkSignalsToContext = ({
  signals,
  degradedTrigger,
}: AdaptNetworkSignalsToContextArgs): NetworkQualityContext => ({
  trigger: signals.isOnline ? degradedTrigger : NETWORK_TRIGGER.OFFLINE,
  effectiveType: signals.effectiveType,
  rtt: signals.rtt,
  downlink: signals.downlink,
  measuredDownlinkMbps: signals.measuredDownlinkMbps,
  rollingAverageLatencyMs: signals.rollingAverageLatencyMs,
  hasNetworkMeasurement: signals.hasNetworkMeasurement,
  latencySource: signals.latencySource,
  timeoutCountInWindow: signals.timeoutCountInWindow,
});
